import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CustomValidator } from '../../../validators/custom.validator';
import { CustomerExistValidator } from '../../../validators/customer-phone-number-exist-validator';
import { UniqueNipValidator } from '../../../validators/unique-nip.validator';
import { ValidatorPatterns } from '../../../validators/validator-patterns';

export class CustomerForm extends UntypedFormGroup {
  constructor(private uniqueNipValidator: UniqueNipValidator, private customerExistValidator: CustomerExistValidator) {
    
    super({
      id: new UntypedFormControl(null),
      name: new UntypedFormControl(null),
      lastName: new UntypedFormControl(null, [
        Validators.pattern(ValidatorPatterns.lastname)
      ]),
      firstName: new UntypedFormControl(null, [
        Validators.pattern(ValidatorPatterns.lastname)
      ]),
      companyFullName: new UntypedFormControl(null),
      companyShortName: new UntypedFormControl(null),
      phoneNumber: new UntypedFormControl(null, [Validators.required,Validators.minLength(9),Validators.maxLength(9),Validators.pattern(ValidatorPatterns.phone)]),
      address: new UntypedFormControl(null, [Validators.required, Validators.pattern(ValidatorPatterns.address)]),
      city: new UntypedFormControl(null, [Validators.required, Validators.pattern(ValidatorPatterns.onlyLetters)]),
      postalCode: new UntypedFormControl(null, [Validators.required, Validators.pattern(ValidatorPatterns.postalCode), Validators.maxLength(6)]),
      nip: new UntypedFormControl(
        null,
        [Validators.required,  Validators.minLength(10), Validators.pattern(ValidatorPatterns.nip)],
        uniqueNipValidator.createValidator()
      ),
      isBlackListed: new UntypedFormControl(false),
      email: new UntypedFormControl(null, [Validators.pattern(ValidatorPatterns.email)]),
      // purchaserContactEmail: [null, [Validators.required, Validators.pattern(ValidatorPatterns.email)]],
      isCompany: new UntypedFormControl(true),
      isIndividual: new UntypedFormControl(false),
      merchantLimit: new UntypedFormControl(null, [Validators.pattern(ValidatorPatterns.merchantLimit)]),
      customerType: new UntypedFormControl('Firma'),
      bricklayer: new UntypedFormControl(false),
      uniqueAbbreviation: new UntypedFormControl(null, [
        Validators.minLength(2),
        Validators.maxLength(55),
      ]),
      pesel: new UntypedFormControl(null),
    });
  }

  setCustomerTypeValidators(): void {
    // Object.keys(this.form.controls).forEach(key => {
    //   this.form.get(key).updateValueAndValidity();
    // });
    // tslint:disable-next-line:no-unused-expression
    this.controls['pesel'].updateValueAndValidity();

    if(this.get('customerType').value === 'Firma' || this.get('customerType').value === 'Pośrednik'){
      this.controls['companyShortName'].setValidators(Validators.required);
      this.controls['companyFullName'].setValidators(Validators.required);
      this.controls['nip'].setValidators([Validators.required,  Validators.minLength(10), Validators.pattern(ValidatorPatterns.nip)]);
      this.controls['firstName'].clearValidators();
      this.controls['lastName'].clearValidators();
      if (this.get('customerType').value === 'Pośrednik') {
        this.controls.isCompany.setValue(false);
      } else {
        this.controls.isCompany.setValue(true);
      }
     }
    else{
      this.controls.isCompany.setValue(false);
      this.controls['companyShortName'].clearValidators();
      this.controls['companyFullName'].clearValidators();
      this.controls['nip'].clearValidators();
    }

    

    if (this.get('customerType').value === 'Fizyczna') {
      this.clearValidators();
      this.updateValueAndValidity();
      this.controls['firstName'].setValidators([Validators.required, Validators.pattern(ValidatorPatterns.firstname)])
      this.controls['lastName'].setValidators([Validators.required, Validators.pattern(ValidatorPatterns.lastname)])
    }

      // ? this.form.controls.isCompany.setValue(true)
      // : this.form.controls.isCompany.setValue(false);
      // this.form.controls['companyShortName'].setValidators(Validators.required);
      // this.form.controls['companyFullName'].setValidators(Validators.required);
      //Nazwa firmy - companyfullname
      //skrocona nf - companyshortname

    this.get('customerType').value === 'Pośrednik'
      ? this.controls.bricklayer.setValue(true)
      : this.controls.bricklayer.setValue(false);
  
    this.controls['firstName'].updateValueAndValidity();
    this.controls['lastName'].updateValueAndValidity();
    this.controls['companyShortName'].updateValueAndValidity();
    this.controls['companyFullName'].updateValueAndValidity();
    this.controls['nip'].updateValueAndValidity();
  }

  // Validators.pattern('^[a-zA-Z0-9_\\.+-]+$'),
  forAdd() {
    this.controls["phoneNumber"].setAsyncValidators(this.customerExistValidator.createValidator());
    return this;
  }

  forEdit() {
    return this;
  }
}
